var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "var(--secondary-green-200)",
    fillRule: "nonzero",
    width: 54,
    height: 54,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#4AA147",
    fillRule: "nonzero",
    x: 11.25,
    y: 11.25,
    width: 31.5,
    height: 31.5,
    rx: 1.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.543 20.532c1.543 0 2.432.836 2.504 2.334l.004.2v9.762h2.461v-1.751a1.993 1.993 0 01-1.419-1.765l-.005-.15v-1.483c0-1.107.891-1.998 1.998-1.998s1.998.891 1.998 1.998v1.483c0 .774-.436 1.443-1.077 1.775l-.001 1.89 1.172.002c.371 0 .672.334.672.747 0 .37-.244.679-.563.737l-.11.01h-14.38c-.371 0-.672-.335-.672-.747 0-.372.244-.68.563-.738l.11-.01h.158v-9.763c0-1.554.83-2.456 2.317-2.529l.198-.004h4.072zm0 1.12h-4.072c-.932 0-1.345.362-1.39 1.242l-.004.171-.001 9.763h2.9V31.05c0-.309.335-.56.747-.56.367 0 .672.198.735.46l.012.1v1.778h2.46v-9.763c0-.948-.353-1.363-1.219-1.409l-.168-.004zm5.543 5.15a.873.873 0 00-.878.877v1.483c0 .488.39.877.878.877s.878-.39.878-.877v-1.483a.873.873 0 00-.878-.878zm-5.915-.396c.309 0 .56.335.56.747 0 .367-.198.672-.46.735l-.1.012h-3.236c-.31 0-.56-.334-.56-.747 0-.367.198-.672.46-.735l.1-.012h3.236zm0-2.45c.309 0 .56.334.56.747 0 .366-.198.671-.46.735l-.1.012h-3.236c-.31 0-.56-.335-.56-.747 0-.367.198-.672.46-.735l.1-.012h3.236z",
    fill: "#FFFFFE",
    fillRule: "nonzero"
  }))));
}
export default SvgOrg;